import { ListItem } from '../../../../search/search-model';

export interface PersonWithGuid {
	guid: string
}

export interface CoveredPeople extends ListItem {
	guid: string;
	tax_id: string;
	masked_tax_id: string;
	ae_available: boolean;
	clergy: boolean;
	first_name: string;
	middle_name: string;
	last_name: string;
	suffix: string;
	salutation: string;
	full_name: string;
	client_number: string;
	masked_client_number: string;
	date_of_birth: string;
	masked_date_of_birth: string;
	mailing_address_city: string;
	dependent_count: number;
	oe_status?: string;
	annual_enrollment_action: string; // NOTE:  This should be a derived field and not one which comes from the API.  I have built a key-value list in Epi to map the annual_enrollment_status to the correct action text.  
	//	Ex: const actionText = searchSettings?.annualEnrollmentActionTextMapping.find((value) => value.key === casted?.annual_enrollment_status)?.value;
}

export interface BillingAddress {
	billing_address_address1: string;
	billing_address_address2: string;
	billing_address_city: string;
	billing_address_state: string;
	billing_address_postal_code: string;
	billing_address_country: string;
}
export interface BillingAccountDetail {
	group_id: string;
	group_name: string;
	group_client_number: string;
	account_owner_client_number: string;
	billing_account_number: string;
	account_owner_name: string;
	account_owner_org_name: string;
	account_owner_billing_address: BillingAddress;
	covered_people: CoveredPeople[];
	account_phone_country_code: string;
	account_phone_area_code: string;
	account_phone_number: string;
	account_phone_extension: string;

}

export interface ParticipantsState {
	billingAccountDetail: BillingAccountDetail;
	billingAccountDetailLoaded: boolean;
	requesting: boolean;
}

export enum ParticipantsStateActions {
	SET_BILLING_ACCOUNT_DETAIL = 'SET_BILLING_ACCOUNT_DETAIL',
	UNLOAD_BILLING_ACCOUNT_DETAIL_STATE = 'UNLOAD_BILLING_ACCOUNT_DETAIL_STATE',
	BEGIN_REQUEST_BILLING_ACCOUNT_DETAIL = 'BEGIN_REQUEST_BILLING_ACCOUNT_DETAIL',
	END_REQUEST_BILLING_ACCOUNT_DETAIL = 'END_REQUEST_BILLING_ACCOUNT_DETAIL',
}